/* @ngInject */
function formattedDateFromNow ($rootScope, $translate) {
  return function (date) {
    let formattedDate = moment(date).fromNow()

    const texts = {
      'PT-BR': 'há poucos segundos',
      'EN-US': 'a few seconds ago',
      'ES-ES': 'hace unos segundos'
    }

    if (formattedDate === texts[$rootScope.oUser?.locale || 'PT-BR']) {
      formattedDate = $translate.instant('now')
    }

    return formattedDate
  }
}

export { formattedDateFromNow }
